import ProfileImageCropModal from '@/features/profile/edit/crop/ProfileImageCropModal';
import { useProfileImageCropStore } from '@/features/profile/edit/crop/profileImageCropStore';

export default function ProfileImageCropModalHost() {
  const isOpen = useProfileImageCropStore((state) => state.isOpen);
  const target = useProfileImageCropStore((state) => state.target);
  const imageSrc = useProfileImageCropStore((state) => state.imageSrc);
  const cancel = useProfileImageCropStore((state) => state.cancel);

  if (!isOpen || !target || !imageSrc) {
    return null;
  }

  return <ProfileImageCropModal target={target} imageSrc={imageSrc} onClose={cancel} />;
}
